// import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
// import { persistCombineReducers } from 'redux-persist'
import AuthReducer from "./AuthReducer";
import { combineReducers } from "redux";
import AgentReducer from "./AgentReducer";
import RedmineReducer from "./RedmineReducer";
import CallReducer from "./CallReducer";

const rootReducer = combineReducers({
  Auth: AuthReducer,
  Agent: AgentReducer,
  Redmine: RedmineReducer,
  Call: CallReducer,
});

export default rootReducer;
